import activityFactory from '@polleverywhere/core/lib/activity_factory'
import ErrorModel from '../models/error'
import fetchActivity from './fetch_activity'

export default async function (type = '', permalink = '', options = { fetch: true }) {
  type = type.replace(/s$/, '')

  const activity = activityFactory({
    type,
    permalink
  })

  if (!activity) {
    return new ErrorModel({ code: 404 })
  }

  if (!options.fetch) {
    return activity
  }

  return fetchActivity(activity)
}
